
import { createWeb3Modal } from '@web3modal/wagmi'
import { WagmiProvider, createConfig, http } from 'wagmi'
import { PROJECT_ID } from '@/lib/web3Config'
import { bsc } from 'wagmi/chains'
import { ReactNode } from 'react'
import { 
  injected,
  metaMask,
  walletConnect,
  coinbaseWallet
} from '@wagmi/connectors'

// Create wagmi config
export const config = createConfig({
  chains: [bsc],
  transports: {
    [bsc.id]: http('https://bsc-dataseed.binance.org'),
  },
  connectors: [
    injected(),
    metaMask(),
    walletConnect({
      projectId: PROJECT_ID,
      showQrModal: true,
      metadata: {
        name: 'BroMENtum',
        description: 'A decentralized insurgency built for men who are DONE being NPCs.',
        url: window.location.origin,
        icons: [`${window.location.origin}/assets/bromentum logo.jpg`]
      }
    }),
    coinbaseWallet({
      appName: 'BroMENtum',
    })
  ]
})

// Configure web3modal
export const web3Modal = createWeb3Modal({
  wagmiConfig: config,
  projectId: PROJECT_ID,
  themeMode: 'dark',
  themeVariables: {
    '--w3m-font-family': '"Patrick Hand", cursive',
    '--w3m-accent': '#e7d4cc',
    '--w3m-background-color': '#19152a',
    '--w3m-text-big-bold-font-family': '"Permanent Marker", cursive',
  } as Record<string, string>,
  defaultChain: bsc,
  enableAnalytics: false,
  enableOnramp: false,
})

export function Web3Provider({ children }: { children: ReactNode }) {
  return (
    <WagmiProvider config={config}>
      {children}
    </WagmiProvider>
  )
}
